import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Helpers de formulário
import InputMask from 'react-input-mask';
import Select from 'react-select';
import Toggle from 'react-toggle';
import getLocale from '../../../i18n/getLocale';

class StaffPeriodsTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: false,
      staff_id: this.props.staff_id,
      date_start: '',
      staff_periods: [],
      schedule_regime_id: null,
      staff_regimes_select: [],
    };

    //bind específico
    // this.add = this.add.bind(this);
    // this.activate = this.activate.bind(this);
    // this.archive = this.archive.bind(this);
    // this.delete = this.delete.bind(this);
    this.refreshData = this.refreshData.bind(this);

    this.locale = getLocale();
  }
  // Handlers
  // handleChange (name, event) {
  //   var change = {};
  //   change[name] = event.target.value;
  //   this.setState(change);
  // }
  // handleSelectChange(name, event) {
  //   var change = {};
  //   if(event == null) {
  //     change[name] = null;
  //   } else {
  //     change[name] = event.value;
  //   }
  //   this.setState(change);
  // }
  // handleToggleChange (name, event) {
  //   var change = {};
  //   if (event.target.checked === true) {
  //     var value = 1;
  //   } else {
  //     var value = 0;
  //   }
  //   change[name] = value;
  //   this.setState(change);
  // }
  // LM
  componentWillReceiveProps(newProps) {
    if(Array.isArray(newProps.staff_periods) && this.state.loaded === false) {
      this.setState({
        staff_regimes_select: newProps.staff_regimes_select,
        staff_periods: newProps.staff_periods,
        loaded: true
      });
    }
  }

  // Fetch salvando a edição
  // add(event) {
  //   event.preventDefault();
  //   this.props.handleAlert('', '', 'open');
  //   var datasave = {
  //     staff_id: this.state.staff_id,
  //     schedule_regime_id: this.state.schedule_regime_id,
  //     date_start: this.state.date_start,
  //   };
  //   var header = this.refs.request_api.header('application/json');
  //   var self = this;
  //   Promise.resolve(header).then(function(value) {
  //     fetch(config.get('api') + '/funcionario/quinzena', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
  //       self.refs.request_api.validate(responseJson, 'alert');
  //       self.refreshData();
  //       self.props.handleAlert(responseJson.message, responseJson.status, 'open');
  //     }).catch((error) => {
  //       console.error(error);
  //     });
  //   });
  // }

  // // Fetch ativando um item
  // activate(event) {
  //   var id = event.currentTarget.value;
  //   var confirm = window.confirm('Tem certeza que gostaria de ativar essa quinzena?');
  //   if (confirm) {
  //     this.props.handleAlert('', '', 'open');
  //     var datasave = {
  //       id: id,
  //     };
  //     var header = this.refs.request_api.header('application/json');
  //     var self = this;
  //     Promise.resolve(header).then(function(value) {
  //       fetch(config.get('api') + '/funcionario/quinzena/ativar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
  //         self.refs.request_api.validate(responseJson, 'alert');
  //         if (responseJson.status === 'success') {
  //           self.refreshData();
  //         }
  //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
  //       }).catch((error) => {
  //         console.error(error);
  //       });
  //     });
  //   }
  // }

  // // Fetch deletando um item
  // archive(event) {
  //   var id = event.currentTarget.value;
  //   var confirm = window.confirm('Tem certeza que gostaria de arquivar essa quinzena?');
  //   if (confirm) {
  //     this.props.handleAlert('', '', 'open');
  //     var header = this.refs.request_api.header('application/json');
  //     var self = this;
  //     Promise.resolve(header).then(function(value) {
  //       fetch(config.get('api') + '/funcionario/quinzena/arquivar/' + id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
  //         self.refs.request_api.validate(responseJson, 'alert');
  //         if (responseJson.status === 'success') {
  //           self.refreshData();
  //         }
  //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
  //       }).catch((error) => {
  //         console.error(error);
  //       });
  //     });
  //   }
  // }

  // // Fetch deletando um item
  // delete(event) {
  //   var id = event.currentTarget.value;
  //   var confirm = window.confirm('Tem certeza que gostaria de deletar essa quinzena?');
  //   if (confirm) {
  //     this.props.handleAlert('', '', 'open');
  //     var header = this.refs.request_api.header('application/json');
  //     var self = this;
  //     Promise.resolve(header).then(function(value) {
  //       fetch(config.get('api') + '/funcionario/quinzena/' + id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
  //         self.refs.request_api.validate(responseJson, 'alert');
  //         if (responseJson.status === 'success') {
  //           self.refreshData();
  //         }
  //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
  //       }).catch((error) => {
  //         console.error(error);
  //       });
  //     });
  //   }
  // }

  refreshData () {
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/funcionario/quinzenas/' + self.state.staff_id, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.setState({staff_periods: responseJson.data});
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
  <h3 className="page-title">{this.locale.ColaboradoresSigtrip.EditarFuncionario.tabRegimes.tituloRegimes}</h3>
  <hr/>
  {(this.state.staff_periods === null || typeof this.state.staff_periods === 'undefined') ?  <div><small><em>{this.locale.ColaboradoresSigtrip.EditarFuncionario.tabRegimes.nenhumRegimeCadastrado}</em></small><hr/></div>
  :
  <div>
    <table className="table table-bordered table-stripped table-hover">
      <thead>
        <tr>
          <th className="text-center">{this.locale.ColaboradoresSigtrip.EditarFuncionario.tabRegimes.tabela.Regime}</th>
          <th className="text-center">{this.locale.ColaboradoresSigtrip.EditarFuncionario.tabRegimes.tabela.Data}</th>
          <th className="text-center">{this.locale.ColaboradoresSigtrip.EditarFuncionario.tabRegimes.tabela.Mes}</th>
          <th className="text-center">{this.locale.ColaboradoresSigtrip.EditarFuncionario.tabRegimes.tabela.Ano}</th>
          <th className="col-md-1 text-center">{this.locale.ColaboradoresSigtrip.EditarFuncionario.tabRegimes.tabela.Status}</th>
        </tr>
      </thead>
      <tbody id="suppliers-certifications">
        {Object.keys(self.state.staff_periods).map(function(k) {
          return (
            <tr>
              <td className="text-center">{self.state.staff_periods[k].schedule_regime}</td>
              <td className="text-center">{self.state.staff_periods[k].date_start_str}</td>
              <td className="text-center">{self.state.staff_periods[k].month}</td>
              <td className="text-center">{self.state.staff_periods[k].year}</td>
              <td className="text-center">{(self.state.staff_periods[k].active === 1) ?  <span className="label label-success">{self.locale.ColaboradoresSigtrip.EditarFuncionario.tabRegimes.tabela.Ativo}</span> : <span className="label label-danger">{self.locale.ColaboradoresSigtrip.EditarFuncionario.tabRegimes.tabela.Arquivado}</span>}</td>
              {/* <td className="text-center">
                {(self.state.staff_periods[k].active === 1) ?
                  <button className="btn btn-sm btn-danger" value={self.state.staff_periods[k].id} onClick={self.archive}><i className="fa fa-fw fa-power-off"></i></button>
                  :
                  <button className="btn btn-sm btn-success" value={self.state.staff_periods[k].id} onClick={self.activate}><i className="fa fa-fw fa-power-off"></i></button>
                }
                <button className="btn btn-sm btn-danger" value={self.state.staff_periods[k].id} onClick={self.delete}>
                  <i className="fa fa-fw fa-trash"></i>
                </button>
              </td> */}
            </tr>
          );
        })}
      </tbody>
    </table>
    <hr/>
  </div>
  }
  {/* <h3 className="page-title">Cadastrar regime</h3>
  <hr/>
  <form onSubmit={this.add}>
    <div className="row">
      <div className="col-md-6 form-group">
        <label>Regime:</label>
        <Select
          className="form-field-name"
          name="schedule_regime_id"
          value={this.state.schedule_regime_id}
          searchable={true}
          placeholder={''}
          onChange={this.handleSelectChange.bind(this, 'schedule_regime_id')}
          options={this.state.staff_regimes_select}
        />
      </div>
      <div className="col-md-6 form-group">
        <label>Data inicial:</label>
        <InputMask value={this.state.date_start}  maskChar={null} name="date_start" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_start')} placeholder="" />
      </div>
    </div>
    <hr/>
    <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> Salvar regime</button>
  </form> */}
</div>
    );
  }
}

export default StaffPeriodsTab;



// WEBPACK FOOTER //
// ./src/Components/SigtripStaffs/Elements/StaffPeriodsTab.js